import { useRecoilValue } from "recoil";

import { isSelectedIdSF, RydeUiUnit } from "@ryde/shared";

/** Per-row Recoil subscription — only the affected row re-renders on selection change. */
export const useTableRowIsSelected = (
  entity: RydeUiUnit,
  rowId: number,
): boolean => useRecoilValue(isSelectedIdSF([entity, rowId]));
